import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, QueryList, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';

export interface FacultadFaq {
  id: number;
  ask: string;
  answer: string;
  estado: boolean;
  position: number;
  createdAt?: string | null;
  updatedAt?: string | null;
}

@Component({
  selector: 'app-preguntas-frecuentes-facultdad',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './preguntas-frecuentes-facultdad.component.html',
  styleUrl: './preguntas-frecuentes-facultdad.component.scss'
})
export class PreguntasFrecuentesFacultdadComponent implements AfterViewInit, OnDestroy {
  @Input() info: any;
  @ViewChildren('faqQuestion') faqQuestions!: QueryList<ElementRef<HTMLButtonElement>>;

  expandedFaqs = new Set<number>();
  questionHeight: number | null = null;
  private questionChangesSubscription?: Subscription;

  get faqs(): FacultadFaq[] {
    return (this.info?.venueFaq?.faqs ?? [])
      .filter((faq: FacultadFaq) => faq?.estado)
      .slice()
      .sort((first: FacultadFaq, second: FacultadFaq) => first.position - second.position);
  }

  get accentColor(): string {
    return this.info?.venue?.color || '#003A73';
  }

  ngAfterViewInit(): void {
    this.scheduleQuestionHeightCalculation();
    this.questionChangesSubscription = this.faqQuestions.changes.subscribe(() => {
      this.scheduleQuestionHeightCalculation();
    });
  }

  ngOnDestroy(): void {
    this.questionChangesSubscription?.unsubscribe();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.scheduleQuestionHeightCalculation();
  }

  private scheduleQuestionHeightCalculation(): void {
    // Se elimina la medida anterior para volver a obtener la altura natural
    // cuando cambia el ancho disponible y el texto ocupa más o menos líneas.
    this.questionHeight = null;

    setTimeout(() => {
      const heights = this.faqQuestions?.toArray()
        .map(question => question.nativeElement.getBoundingClientRect().height)
        .filter(height => height > 0) || [];

      this.questionHeight = heights.length ? Math.max(...heights) : null;
    });
  }

  toggleFaq(faqId: number): void {
    if (this.expandedFaqs.has(faqId)) {
      this.expandedFaqs.delete(faqId);
    } else {
      this.expandedFaqs.add(faqId);
    }
  }

  isExpanded(faqId: number): boolean {
    return this.expandedFaqs.has(faqId);
  }

  trackByFaq(_: number, faq: FacultadFaq): number {
    return faq.id;
  }
}
